/**
 * Render Wagtail StreamField content.
 * Uses generated types from the API.
 */

import { BlockTypeEnum } from '@/api/generated';
import type { ContentBlock } from '@/api/generated';

interface StreamFieldProps {
  blocks: ContentBlock[];
}

export default function StreamField({ blocks }: StreamFieldProps) {
  if (!blocks || blocks.length === 0) {
    return null;
  }

  return (
    <div className="prose prose-lg max-w-none">
      {blocks.map((block, index) => (
        <StreamBlockRenderer key={index} block={block} />
      ))}
    </div>
  );
}

function normalizeRichText(html: string): string {
  // Replace empty <p> tags (including with whitespace/br only) with a non-breaking space
  // so they render as visible line spacing rather than collapsing to zero height
  return html.replace(/<p([^>]*)>(\s|<br\s*\/?>)*<\/p>/gi, '<p$1>&nbsp;</p>');
}

function StreamBlockRenderer({ block }: { block: ContentBlock }) {
  switch (block.block_type) {
    case BlockTypeEnum.RichTextBlock:
      return (
        <div
          className="mb-4 leading-relaxed"
          dangerouslySetInnerHTML={{ __html: normalizeRichText(block.value) }}
        />
      );

    default:
      console.warn(`Unknown block type: ${block.block_type}`);
      return null;
  }
}
